import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { ProgressBar } from '../../../ProgressBar'
import { getBirdviewCardBodyContent } from '../BirdviewCard.utils'

import * as styles from './BirdviewCardBody.module.css'

function BirdviewCardBody({
  Skeleton,
  children,
  emptyKey = 'DashboardBirdview.EmptyStateKey',
  isRefreshing,
  skeletonProps,
  state,
  onRetry,
}) {
  const { t } = useTranslation()

  return (
    <div
      className={classNames(styles.body, {
        [styles.refreshing]: isRefreshing,
      })}
    >
      {isRefreshing ? <ProgressBar className={styles.progress} /> : null}
      {getBirdviewCardBodyContent({
        Skeleton,
        children,
        emptyKey,
        skeletonProps,
        state,
        t,
        onRetry,
      })}
    </div>
  )
}

export default BirdviewCardBody
